import { useIntl } from '@leagueplatform/locales';
import type { UserMenuSection } from '@leagueplatform/solutions-foundation';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { INTERNAL_LINKS } from 'common/links';

export const useUserMenuConfig = (): { userMenu: UserMenuSection[] } => {
  const { formatMessage } = useIntl();
  const userMenu: UserMenuSection[] = [
    {
      heading: formatMessage({ id: 'STR_ACCOUNT' }),
      items: [
        {
          label: formatMessage({ id: 'STR_PERSONAL_INFO' }),
          to: INTERNAL_LINKS.PERSONAL_INFO,
        },
        {
          label: formatMessage({ id: 'STR_COMMUNICATION' }),
          to: INTERNAL_LINKS.COMMUNICATION,
        },
      ],
    },
    {
      heading: formatMessage({ id: 'STR_ABOUT' }),
      items: [
        {
          label: formatMessage({ id: 'STR_ABOUT_EOS_HEALTH' }),
          to: INTERNAL_LINKS.ABOUT,
        },
        {
          label: formatMessage({ id: 'STR_PRIVACY_POLICY' }),
          to: INTERNAL_LINKS.POLICY,
        },
        {
          label: formatMessage({ id: 'STR_TERMS_OF_SERVICE' }),
          to: INTERNAL_LINKS.TERMS,
        },
        {
          label: formatMessage({ id: 'STR_DELETE_YOUR_ACCOUNT' }),
          to: INTERNAL_LINKS.DELETE_ACCOUNT,
        },
      ],
    },
    {
      items: [
        {
          label: formatMessage({ id: 'STR_LOG_OUT' }),
          to: APP_MANAGED_ROUTES.SIGN_OUT,
          variant: 'critical',
        },
      ],
    },
  ];

  return { userMenu };
};
